var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.componentes),function(componente,idx){return [(componente === _vm.current)?_c(componente,{key:idx,tag:"component"}):_vm._e()]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }